import React from 'react';

import { Box } from '@chakra-ui/react';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { useSelectedView } from 'reducers/viewsSlice';
import { Loader } from 'screens/analytics/commonComponents';
import { useOneOnOneInsightsFiltersData } from 'screens/oneOnOneRabbit/Insights/slice/OneOnOneInsightsFiltersSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { sendExpandedChartEvent } from 'constants/mixpanelHelper';

import { ExpandableContainerProvider } from 'uiToolkitV1/ExpandableContainerProvider';
import { TextBodyLarge } from 'uiToolkitV1/Typography';

import { useOneOnOneInsightsGraphData } from '../OneOnOneCompletion/hooks/dataHooks';
import ThemeDistributionChart from './ThemeDistributionChart';

const ThemeDistribution = () => {
  const selectedCohort = useSelectedView();

  const { dateRange, groupByKeys } = useOneOnOneInsightsFiltersData();

  const modules = useRouteToNavLevels();
  const isShowReportees = !checkNewNavEnabled() || modules?.l1Module === 'team';

  const { data, isLoading } = useOneOnOneInsightsGraphData({
    cohort: selectedCohort,
    isExpandedViewRequired: false,
    orderBy: null,
    dateRange,
    groupByKeys,
    isShowReportees,
  });
  const chartRef = React.useRef(null);

  return (
    <Box h="348px" data-testid="theme-distribution">
      <ExpandableContainerProvider
        id="oneOnOneCompletion"
        isParentDeterminesHeight
        toggleBtnBoxProps={{ top: '4px !important', right: '4px !important' }}
        onExpand={() => {
          sendExpandedChartEvent({
            eventProperties: {
              source: '1:1s',
              type: 'insights',
            },
          });
        }}
      >
        <Box height="100%" p={4}>
          <Box mb="16px">
            <TextBodyLarge bold>Theme sentiment</TextBodyLarge>
          </Box>

          {isLoading ? (
            <Loader />
          ) : (
            <Box h="calc(100% - 36px)">
              <ThemeDistributionChart data={data} chartRef={chartRef} />
            </Box>
          )}
        </Box>
      </ExpandableContainerProvider>
    </Box>
  );
};

export default ThemeDistribution;
